import ResourceBlockerIntlProvider from './ResourceBlockerIntlProvider'

export default ResourceBlockerIntlProvider
